// application/use-cases/incidente/GetIncidenteByIdUseCase.ts

import { Incidente } from '@/domain/entities/incidente';
import { IIncidenteRepository } from '@/domain/repositories';

export class GetIncidenteByIdUseCase {
  constructor(
    private readonly repository: IIncidenteRepository
  ) {}

  execute(id: string): Promise<Incidente | null> {
    return this.repository.findById(id);
  }
}